export var actionKey = '@@messages';
//# sourceMappingURL=constants.js.map